var map = {
	"./images/ColourGenerator.png": 3291,
	"./images/MacroCounter.png": 1483,
	"./images/MathWiz.png": 9922,
	"./images/Notes.png": 3191,
	"./images/PasswordGenerator.png": 1622,
	"./images/Pokedex.png": 7225,
	"./projectCard": 1196,
	"./projectCard.scss": 7130,
	"./projectCard.tsx": 1196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8891;